module.exports = __webpack_public_path__ + "img/syukyaku-top-010.bdbe69a4.jpg";